import { HiHome } from "react-icons/hi2";

export const HomeIcon = ({ width, height, color, ...props }) => (
  <HiHome
    size={width || height || 22}
    color={color || "currentColor"}
    {...props}
  />
);
